import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormaListasChequeo, FormularioListaChequeo } from '@app/shared';
import { LocalDataSource } from 'ng2-smart-table';
import { Subject } from 'rxjs';
import { ManagementCheckListFormConfigService } from './shared/management-check-list-from.config.service';

@Component({
  selector: 'iw-management-check-list-form',
  templateUrl: './management-check-list-form.component.html',
  styleUrls: ['./management-check-list-form.component.scss']
})
export class ManagementCheckListFormComponent implements OnInit, OnDestroy {

  // Contiene la informacion de las listas de chequeo de la forma seleccionada
  @Input() formsCheckList: FormaListasChequeo;
  // Contiene las opciones de cada lista de chequeo
  @Input() optionsForm: any = {};
  // Configuracion de la tabla
  settings = {};
  // Contiene la informacion de las listas de chequeo de la forma seleccionada
  recordsSelect: number[] = [];
  // Contiene los datos de la tabla previamente seteados y listos para renderizar en la tabla
  sourceData: LocalDataSource;
  // Contiene el registro seleccionado
  checkListSelected: FormularioListaChequeo;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();

  constructor() { }

  ngOnInit() {
    if (!this.optionsForm) {
      this.optionsForm = {};
    }
    this.sourceData = new LocalDataSource(this.formsCheckList.formularios);
    // Se inicia la configuracion de la tabla
    const configTable = new ManagementCheckListFormConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((data: FormularioListaChequeo) => {
      if (this.optionsForm && Object.keys(this.optionsForm).length) {
        if (
          this.optionsForm[data.alias] &&
          this.optionsForm[data.alias].length
        ) {
          this.recordsSelect = this.optionsForm[data.alias];
        } else {
          this.recordsSelect = [];
        }
      } else {
        this.recordsSelect = [];
      }
      this.checkListSelected = data;
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Retorna las configuraciones de las listas de chequeo
   *
   * @returns {*}
   * @memberof ManagementCheckListFormComponent
   */
  getSpecificRecords(): any {
    return this.optionsForm;
  }

  /**
   * Refrescar la tabla de listas de chequeo
   *
   * @memberof ManagementCheckListFormComponent
   */
  refresh() {
    this.sourceData = new LocalDataSource(this.formsCheckList.formularios);
    this.sourceData.refresh();
  }

  /**
   * Setea los registros especificos de una lista de chequeo
   *
   * @param {number[]} records
   * @memberof ManagementCheckListFormComponent
   */
  setSpecificRecords(records: number[]) {
    this.optionsForm[this.checkListSelected.alias] = records;
  }

  /**
   * Cierra la tabla de registros especificas de la lista de chequeo seleccionada
   *
   * @memberof ManagementCheckListFormComponent
   */
  close() {
    this.checkListSelected = undefined;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/basic-process-configuration/management-check-list-form/management-check-list-form.component.ts